<template>
    <!-- App Section -->
	<section class="app-five-section">
		<div class="container">
			<div class="app-sec app-sec-five">
				<div class="row align-items-end">
					<div class="col-lg-6 col-12">
						<div class="app-five-content">
							<div class="col-md-12">
								<div class="heading aos" data-aos="fade-up">
									<h2>Download Our App</h2>
									<p>
										Whether you're looking to our app brings everything you need right
										to your fingertips.
									</p>
									<h6>Scan the QR code to get the app now</h6>

								</div>
							</div>
							<div class="downlaod-btn aos" data-aos="fade-up">
								
								<a href="javascript:void(0);">
									<img src="@/assets/img/appstore-five.svg" alt="img">
								</a>
								<a href="javascript:void(0);">
									<img src="@/assets/img/googleplay-five.svg" alt="img">
								</a>
							</div>
						</div>
					</div>
					<div class="col-lg-6 col-12">
						<div class="appimg-set aos d-none d-lg-block" data-aos="fade-up">
							<img src="@/assets/img/app-sec-five.png" class="img-fluid" alt="img">
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- /App Section -->
</template>